import react from "react";
import '../css/Common.css'
const Support = () => {
  return (
    <div className="page-container">
      <h1>Support</h1>
      <p>If you need help, contact us:</p>
      <p>Email: lp6669349@gmail.com</p>
      <p>Phone: +91 8120239904</p>
    </div>
  );
};
export default Support;